import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'ui-movie-card-placeholder',
  standalone: true,
  imports: [CommonModule, SkeletonModule],
  templateUrl: './ui-movie-card-placeholder.component.html',
  styleUrl: './ui-movie-card-placeholder.component.scss'
})
export class UiMovieCardPlaceholderComponent {
  @Input() orientation: 'landscape' | 'portrait' = 'portrait';

  get aspectRatio() {
    return this.orientation === 'landscape'
      ? 'var(--aspect-ratio-landscape, 16:9)'
      : 'var(--aspect-ratio-portrait, 2/3)';
  }
}
